export const CLOSE_TEST_ID = 'close';
export const ZOOM_TEST_ID = 'zoom';
export const IMAGE_CONTAINER_TEST_ID = 'imageContainer';
